import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './canalTokens.css';

/* PANTALLA DE ACEPTAR INVITACIÓN al Canal (frente invitaciones · 2026-07-19).
   Antes NO existía: el email llevaba a /canal/invitacion?token=… y no había
   página → se quedaba EN BLANCO. Esta pantalla:
     1) pregunta el estado del enlace (GET …/estado) sin consumir el token,
     2) si la invitada es NUEVA → elige contraseña → activa → autologin → mi-espacio,
     3) si YA tiene cuenta → activa el acceso → va al login del Canal a entrar,
     4) enlace inválido/usado/caducado → mensaje claro (no pantalla muerta).
   Estética del Canal (fondo oscuro + logos en blanco + campo claro + botón verde). */

const FONDO_CANAL = '/fondo-canal.jpg';

export default function InvitacionCanal({ onLogin = async () => {} }) {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [cargando, setCargando] = useState(true);
  const [estado, setEstado] = useState(null);   // {valido, ya_usado, caducada, cuenta, nombre, email}
  const [password, setPassword] = useState('');
  // Repetir contraseña (Ann 2026-07-20): si se equivoca al teclear la única vez
  // que la escribe, se queda fuera de su propia invitación y sin saber por qué.
  const [password2, setPassword2] = useState('');
  const [pwErr, setPwErr] = useState(false);
  const [errTxt, setErrTxt] = useState('');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    let vivo = true;
    if (!token) { setEstado({ valido: false, motivo: 'TOKEN_INVALIDO' }); setCargando(false); return undefined; }
    axios.get(`/api/canal/invitaciones/estado?token=${encodeURIComponent(token)}`)
      .then((r) => { if (vivo) setEstado(r.data); })
      .catch(() => { if (vivo) setEstado({ valido: false, motivo: 'ERROR' }); })
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [token]);

  const nueva = estado && estado.cuenta === 'nueva';

  const aceptar = async () => {
    setErrTxt('');
    // Cuenta NUEVA → contraseña obligatoria (política backend: 8+, letra y número).
    if (nueva) {
      if (password.length < 8 || !/[A-Za-zÁÉÍÓÚáéíóúÑñ]/.test(password) || !/\d/.test(password)) {
        setPwErr(true); setErrTxt('La contraseña debe tener 8 caracteres o más, con al menos una letra y un número.'); return;
      }
      if (password !== password2) {
        setPwErr(true); setErrTxt('Las dos contraseñas no coinciden.'); return;
      }
    }
    setEnviando(true);
    try {
      await axios.post('/api/canal/invitaciones/activar', nueva ? { token, password } : { token });
      try { localStorage.setItem('canal_clienta', '1'); } catch (e) { /* noop */ }
      if (nueva) {
        // Autologin con el email de la invitación + la contraseña recién elegida.
        try {
          await onLogin(estado.email, password);
          window.location.href = '/mi-espacio';
        } catch (e) {
          // El acceso ya quedó activado; si el autologin falla, a la puerta del Canal.
          window.location.href = '/entrar?puerta=canal';
        }
      } else {
        // Cuenta existente: el acceso quedó activado → entra con su contraseña de siempre.
        window.location.href = '/entrar?puerta=canal';
      }
    } catch (err) {
      const det = err && err.response && err.response.data && err.response.data.detail;
      const code = (det && det.code) || det;
      if (code === 'TOKEN_YA_USADO') setErrTxt('Este enlace ya se usó. Si ya tienes acceso, entra desde el Canal.');
      else if (code === 'TOKEN_INVALIDO') setErrTxt('El enlace no es válido.');
      else if (typeof code === 'string') setErrTxt(code);
      else setErrTxt('No se pudo activar el acceso. Inténtalo de nuevo.');
      setEnviando(false);
    }
  };

  const wrap = {
    minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    padding: '32px 18px', fontFamily: "'Poppins','Montserrat',system-ui,sans-serif",
    background: `linear-gradient(rgba(7,26,26,.9),rgba(7,26,26,.94)), url('${FONDO_CANAL}') center/cover no-repeat, #071a1a`,
  };
  const card = {
    width: '100%', maxWidth: 460, background: 'rgba(9,32,31,.82)', border: '1px solid rgba(255,255,255,.12)',
    borderRadius: 24, padding: 'clamp(24px,4vw,32px)', backdropFilter: 'blur(8px)',
    boxShadow: '0 40px 80px -30px rgba(0,0,0,.6)', color: '#fff',
  };
  const Logos = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 22 }}>
      <img src="/logo-pd.png" alt="Pilar Domínguez" style={{ height: 38, width: 'auto', filter: 'brightness(0) invert(1)' }} />
    </div>
  );

  if (cargando) {
    return (
      <div style={wrap}><Logos />
        <div style={card}><p style={{ margin: 0, textAlign: 'center', color: '#a9c2bf' }}>Comprobando tu invitación…</p></div>
      </div>
    );
  }

  // Enlace no válido / usado / caducado
  if (!estado || !estado.valido) {
    const msg = estado && estado.caducada
      ? 'Esta invitación ha caducado.'
      : (estado && estado.ya_usado)
        ? 'Esta invitación ya se usó. Si ya tienes acceso, entra desde el Canal.'
        : 'El enlace de invitación no es válido.';
    return (
      <div style={wrap}><Logos />
        <div style={card}>
          <div style={{ fontSize: 'clamp(22px,3vw,28px)', fontWeight: 800, lineHeight: 1.15, marginBottom: 10 }}>Invitación al Canal</div>
          <p style={{ margin: '0 0 20px', color: '#c9dedb', fontSize: 15 }}>{msg}</p>
          <a href="/entrar?puerta=canal" style={{
            display: 'block', textAlign: 'center', textDecoration: 'none', color: '#fff', fontWeight: 700, fontSize: 16,
            background: 'var(--verde-boton-grad)', padding: '15px 26px', borderRadius: 13,
          }}>Entrar al Canal</a>
        </div>
      </div>
    );
  }

  const nombre = (estado.nombre || '').trim();
  return (
    <div style={wrap}><Logos />
      <div style={card}>
        <div style={{ fontSize: 'clamp(24px,3vw,30px)', fontWeight: 800, lineHeight: 1.12 }}>
          {nombre ? `¡Hola, ${nombre}!` : '¡Hola!'}
        </div>
        <p style={{ margin: '10px 0 4px', fontSize: 15.5, color: '#cbe3df' }}>
          Te han invitado al <strong>Canal Pilar Domínguez</strong>. Tienes acceso gratuito durante un mes.
        </p>

        <form onSubmit={(e) => { e.preventDefault(); aceptar(); }} noValidate style={{ marginTop: 18 }}>
          {nueva && (
            <>
              <label style={{ display: 'block', fontSize: 13.5, color: '#a9c2bf', margin: '0 2px 6px' }}>Elige una contraseña para tu acceso</label>
              <div style={{ display: 'flex', alignItems: 'center', background: '#F2FAF7', border: `1.5px solid ${pwErr ? '#ff9b8a' : '#cfe4de'}`, borderRadius: 13, padding: '2px 2px 2px 16px' }}>
                <input type="password" value={password} disabled={enviando} autoComplete="new-password"
                  onChange={(e) => { setPassword(e.target.value); if (pwErr) setPwErr(false); if (errTxt) setErrTxt(''); }}
                  placeholder="Mínimo 8 caracteres, con letra y número" aria-label="Contraseña" aria-invalid={pwErr}
                  style={{ flex: 1, minWidth: 0, background: 'transparent', border: 0, outline: 'none', color: '#16323a', fontFamily: 'inherit', fontSize: 15, padding: '14px 12px 14px 0' }} />
              </div>
              <label style={{ display: 'block', fontSize: 13.5, color: '#a9c2bf', margin: '14px 2px 6px' }}>Repite la contraseña</label>
              <div style={{ display: 'flex', alignItems: 'center', background: '#F2FAF7', border: `1.5px solid ${pwErr ? '#ff9b8a' : '#cfe4de'}`, borderRadius: 13, padding: '2px 2px 2px 16px' }}>
                <input type="password" value={password2} disabled={enviando} autoComplete="new-password"
                  onChange={(e) => { setPassword2(e.target.value); if (pwErr) setPwErr(false); if (errTxt) setErrTxt(''); }}
                  placeholder="La misma otra vez" aria-label="Repite la contraseña" aria-invalid={pwErr}
                  style={{ flex: 1, minWidth: 0, background: 'transparent', border: 0, outline: 'none', color: '#16323a', fontFamily: 'inherit', fontSize: 15, padding: '14px 12px 14px 0' }} />
              </div>
            </>
          )}
          {!nueva && (
            <p style={{ margin: '0 2px 4px', fontSize: 14, color: '#a9c2bf' }}>Ya tienes cuenta. Pulsa para activar tu acceso e inicia sesión con tu contraseña de siempre.</p>
          )}
          {errTxt && <p style={{ margin: '8px 2px 0', color: '#ffcf72', fontSize: 13, fontWeight: 600 }}>{errTxt}</p>}
          <button type="submit" disabled={enviando} style={{
            marginTop: 14, width: '100%', border: 0, cursor: 'pointer', fontFamily: 'inherit', fontSize: 16, fontWeight: 700,
            color: '#fff', background: 'var(--verde-boton-grad)', padding: '15px 26px', borderRadius: 13,
            boxShadow: '0 12px 26px -10px rgba(44,102,117,.55)', opacity: enviando ? 0.75 : 1,
          }}>
            {enviando ? 'Activando…' : (nueva ? 'Crear mi acceso y entrar' : 'Activar y entrar')}
          </button>
        </form>
      </div>
    </div>
  );
}
